import { publicRoutePaths } from "@/routes/public.routes.config";
import React from "react";
import { Link } from "react-router-dom";

const TermsAndConditionsBuyerSupplier = () => {
  return (
    <div>
      <p>
        <b>Last Updated:</b> 16 Sept 2026
      </p>

      <p>
        Welcome to <b>Orex Trade World</b>, operated by{" "}
        <b>Orex Trade World INC</b> (“Orex Trade”, “we”, “us”, “our”, or the
        “Platform”).
      </p>
      <p>
        These Terms & Conditions govern your registration, membership, access
        to, and use of the Orex Trade World website, platform, services, Buyer
        inquiries, Supplier services, business opportunities, and related
        features.
      </p>

      <p>
        By registering an account, purchasing a membership, submitting company
        information, listing products, accessing Buyer information, or otherwise
        using Orex Trade World, you agree to these Terms & Conditions.
      </p>

      <p>
        If you do not agree with these Terms, you should not use the Platform or
        purchase any membership or service.
      </p>

      <h2 className="head">1. About Orex Trade World</h2>
      <p>
        <b>
          Orex Trade World is operated by Orex Trade World INC, a United States
          company providing global B2B business networking and facilitation
          services.
        </b>
      </p>

      <p>
        The Platform is designed to connect Buyers, Suppliers, importers,
        exporters, manufacturers, distributors, traders, logistics partners, and
        other business participants across international markets.
      </p>

      <p>
        Depending upon the applicable membership plan, Orex Trade may provide
        services including company profiles, product listings, Supplier
        verification, Buyer inquiries, RFQs, Qualified Buyer Lists,
        Buyer–Supplier introductions, business promotions, Buyer contact
        opportunities, logistics connections, account support, and other
        membership benefits.
      </p>

      <p>
        Orex Trade primarily provides{" "}
        <b>
          business connections, information, visibility, networking
          opportunities, and Platform services
        </b>{" "}
        and does not guarantee successful transactions or business outcomes.
      </p>

      <h2 className="head">2. Platform Role</h2>
      <p>
        Orex Trade facilitates communication and introductions between Buyers
        and Suppliers.
      </p>
      <p>
        Unless expressly agreed otherwise in writing, Orex Trade is not the
        Buyer, Supplier, manufacturer, importer, exporter, seller, purchaser,
        payment guarantor, or contracting party in transactions entered into
        between Platform users.
      </p>
      <p>
        Once a Buyer and Supplier are connected, all commercial negotiations and
        decisions are handled directly between those parties.
      </p>
      <p>
        This may include pricing, product specifications, quantities, samples,
        payment terms, contracts, purchase orders, inspection, shipping,
        insurance, customs, documentation, delivery, warranties, and disputes.
      </p>

      <h2 className="head">3. Membership Plans and Services</h2>
      <p>
        Orex Trade may offer Free, Launch, Growth, Scale, Premium, or other
        membership plans from time to time.
      </p>

      <p>
        The exact services available to a user depend upon the{" "}
        <b>membership plan selected and purchased</b>.
      </p>
      <p>
        Different plans may include different limits or benefits relating to
        product listings, Buyer RFQs, Qualified Buyer contacts, global
        promotions, search visibility, verification, Buyer introductions,
        dedicated account support, and other Platform services.
      </p>
      <p>
        Payment for a membership provides access to the features and services
        included in that membership plan.
      </p>
      <p>
        <b>
          Membership fees are paid for Platform access, services, visibility,
          promotion, networking opportunities, and business opportunities. They
          are not payments for guaranteed orders or guaranteed business results.
        </b>
      </p>

      <h2 className="head">4. Qualified Buyer Lists</h2>
      <p>
        Orex Trade may provide Suppliers with Qualified Buyer Lists, Buyer
        contact information, RFQs, sourcing requirements, and other potential
        business opportunities.
      </p>
      <p>
        For these Terms, a Qualified Buyer means a Buyer or potential business
        opportunity that has been identified, categorized, shortlisted, or
        assessed based on information reasonably available to Orex Trade.
      </p>
      <p>
        Qualification may be based on business requirements, product interest,
        industry, geography, available company information, sourcing activity,
        previous inquiries, or other commercially relevant information.
      </p>

      <p>
        <b>Important Buyer Disclaimer</b>
      </p>
      <p>
        <b>A Qualified Buyer does not mean a guaranteed Genuine Buyer.</b>
      </p>
      <p>
        Orex Trade does not guarantee that every Buyer is genuine, financially
        capable, creditworthy, currently purchasing, authorized to make
        purchasing decisions, ready to place an order, or capable of completing
        a transaction.
      </p>
      <p>
        Buyer information may change after it is received, collected, or
        reviewed.
      </p>
      <p>
        Users are responsible for independently verifying Buyers before entering
        into any commercial or financial transaction.
      </p>

      <h2 className="head">5. Buyer Inquiries and RFQs</h2>
      <p>
        Orex Trade may provide or facilitate access to Buyer inquiries, RFQs,
        sourcing requirements, Buyer contacts, and other business opportunities.
      </p>
      <p>
        An inquiry or RFQ represents a{" "}
        <b>potential business opportunity only.</b>
      </p>
      <p>
        It does not constitute a confirmed purchase order, binding contract,
        guaranteed sale, guaranteed payment, or guaranteed transaction.
      </p>
      <p>
        A Buyer may modify, postpone, withdraw, or cancel a requirement at any
        time.
      </p>
      <p>
        Suppliers should reconfirm the Buyer's requirement before producing
        goods, making shipment arrangements, extending credit, or incurring
        significant expenses.
      </p>

      <h2 className="head">6. No Guarantee of Deal Closure</h2>
      <p>
        Orex Trade connects Buyers and Suppliers{" "}
        <b>but does not guarantee deal closure.</b>
      </p>
      <p>
        Orex Trade does not guarantee any minimum number of orders, Buyer
        responses, purchase orders, sales, export orders, contracts, meetings,
        payments, revenue, repeat business, or return on membership investment.
      </p>
      <p>
        Successful conversion depends upon many factors outside Orex Trade's
        control, including Supplier pricing, product quality, certifications,
        communication, response time, negotiation, Buyer requirements, payment
        terms, delivery schedules, competition, and market conditions.
      </p>
      <p>
        Therefore, failure to convert an inquiry, Qualified Buyer, RFQ, or Buyer
        introduction into a successful transaction shall not by itself
        constitute failure by Orex Trade to provide its services.
      </p>

      <h2 className="head">7. User Registration and Eligibility</h2>
      <p>
        Users registering on Orex Trade must provide accurate and current
        information.
      </p>
      <p>
        By creating an account, you confirm that you are legally capable of
        entering into business arrangements and, where registering on behalf of
        a company, that you are authorized to represent that company.
      </p>
      <p>
        Orex Trade reserves the right to approve, reject, suspend, restrict, or
        request additional information concerning an account or membership
        application.
      </p>
      <h2 className="head">8. Supplier Verification and KYC</h2>
      <p>
        Orex Trade may request business documents for verification and
        compliance purposes.
      </p>
      <p>
        Depending upon the Supplier, country, industry, and services requested,
        documents may include company registration certificates, tax
        registration, GST/VAT documents, Import Export Code, company address
        proof, licenses, product certifications, manufacturing approvals,
        authorized representative information, and other relevant business
        documentation.
      </p>
      <p>
        Orex Trade may request updated or additional information at any time for
        verification, quality control, compliance, or investigation purposes.
      </p>
      <p>
        Submission of materially false, altered, fraudulent, or misleading
        information may result in suspension or termination of the account.
      </p>

      <h2 className="head">9. Verified Supplier Status</h2>
      <p>
        Orex Trade may provide eligible members with a Verified Supplier,
        Certified Supplier, trust badge, or similar verification status.
      </p>
      <p>
        Such status indicates only that Orex Trade has reviewed certain business
        information or documents provided or otherwise available at the time of
        verification.
      </p>
      <p>
        Verification is <b> not a guarantee</b> of product quality, Supplier
        financial strength, creditworthiness, manufacturing capability,
        regulatory compliance, transaction performance, or future conduct.
      </p>
      <p>
        Buyers remain responsible for performing their own due diligence before
        entering into transactions.
      </p>

      <h2 className="head">10. Supplier Responsibilities</h2>
      <p>
        Suppliers are responsible for ensuring that their company information,
        product listings, descriptions, prices, photographs, certifications,
        quotations, and other information are accurate and lawful.
      </p>
      <p>
        Suppliers must maintain all licenses and regulatory approvals required
        for their products or services.
      </p>
      <p>
        Users must not knowingly upload counterfeit products, provide false
        certificates, impersonate another business, submit fraudulent
        information, misuse Buyer information, engage in spam, or conduct
        illegal activities through the Platform.
      </p>

      <h2 className="head">11. Product Listings</h2>
      <p>
        Suppliers are responsible for all products and services listed through
        their accounts.
      </p>
      <p>
        Product descriptions, specifications, availability, certifications,
        images, prices, and other information must not be intentionally false or
        misleading.
      </p>
      <p>
        Orex Trade may remove, restrict, or suspend listings where it reasonably
        believes that a product violates applicable law, Platform policy,
        intellectual property rights, or safety requirements.
      </p>

      <h2 className="head">12. Intellectual Property and Supplier Content</h2>
      <p>
        Users must own or have authorization to use the logos, trademarks,
        photographs, videos, catalogues, product descriptions, and other
        materials they provide to Orex Trade.
      </p>
      <p>
        By submitting business content to the Platform, the Supplier grants Orex
        Trade a non-exclusive, worldwide, royalty-free right to display and use
        that content for purposes related to providing and promoting Orex Trade
        services.
      </p>
      <p>
        This may include use on Orex Trade websites, directories, social media,
        emails, digital promotions, exhibitions, promotional campaigns, and
        other business-development channels.
      </p>
      <p>
        Ownership of Supplier intellectual property remains with the Supplier.
      </p>

      <h2 className="head">13. Use of Buyer Information</h2>
      <p>
        Buyer information received through Orex Trade must be used only for
        legitimate B2B communication and business-development purposes.
      </p>
      <p>
        Users must not sell, resell, publicly distribute, scrape, harvest, or
        provide Buyer information to unrelated third parties.
      </p>
      <p>
        Users must not use Buyer information for unlawful marketing, fraud,
        harassment, excessive spam, or any unauthorized purpose.
      </p>
      <p>
        Orex Trade may restrict Buyer access or suspend an account where misuse
        is detected.
      </p>

      <h2 className="head">14. Buyer and Supplier Due Diligence</h2>
      <p>
        Orex Trade strongly recommends that all Platform users independently
        verify the businesses and persons with whom they intend to transact.
      </p>
      <p>
        Before completing a transaction, users should consider verifying company
        registration, authorized representatives, licenses, purchase orders,
        banking information, payment capability, product documentation, and
        relevant business references.
      </p>
      <p>
        Depending upon transaction risk, users should consider appropriate
        commercial protections such as advance payment, letters of credit,
        escrow, bank guarantees, trade credit insurance, inspection services, or
        other appropriate safeguards.
      </p>
      <p>
        Orex Trade does not guarantee Buyer or Supplier payment or transaction
        performance.
      </p>

      <h2 className="head">15. Fees and Payments</h2>
      <p>
        Paid services are subject to the fees communicated at the time of
        purchase, through the applicable membership page, invoice, quotation, or
        order confirmation.
      </p>
      <p>Applicable taxes or statutory charges may be added where required.</p>
      <p>
        Membership services may become active after successful payment and
        completion of applicable onboarding or verification requirements.
      </p>
      <p>
        Membership validity and benefits shall be determined according to the
        selected plan.
      </p>

      <h2 className="head">16. Cancellation and Refunds</h2>
      <p>
        Membership, verification, promotional, and other digital-service fees
        are generally non-refundable once the applicable service has been
        activated or materially delivered, except where required by applicable
        law or where Orex Trade expressly agrees otherwise in writing.
      </p>
      <p>
        The following circumstances do not automatically qualify for a refund:
      </p>
      <p>
        A Buyer not responding, a Buyer cancelling an inquiry, failure to
        receive an order, failure to close a deal, unsuccessful negotiations,
        disagreement regarding price or payment terms, or failure to achieve
        expected sales or revenue.
      </p>
      <p>
        Please refer to the separate Refund & Cancellation Policy for additional
        information.
      </p>

      <h2 className="head">17. Zero-Commission Policy</h2>
      <p>
        Unless expressly agreed otherwise in writing, Orex Trade does not charge
        commission based on the value of a business transaction concluded
        directly between a Buyer and Supplier.
      </p>
      <p>
        Separate charges may apply for memberships, verification, advertising,
        promotion, marketing, logistics support, premium services, or other
        optional services.
      </p>

      <h2 className="head"> 18. Logistics and Third-Party Services</h2>
      <p>
        Orex Trade may introduce users to freight forwarders, logistics
        companies, customs agents, inspection companies, insurance providers,
        payment providers, or other third-party businesses.
      </p>
      <p>
        Unless expressly stated otherwise, these businesses operate
        independently from Orex Trade.
      </p>
      <p>
        Any agreement entered into with such a third party constitutes a
        separate arrangement between the user and that service provider.
      </p>
      <p>Orex Trade does not guarantee independent third-party performance.</p>

      <h2 className="head"> 19. Professional Conduct</h2>
      <p>
        Users must maintain professional, ethical, and lawful business conduct
        while using Orex Trade.
      </p>
      <p>
        Orex Trade may investigate credible complaints involving fraud,
        misrepresentation, misuse of information, illegal activities, unethical
        business conduct, abusive communication, or other serious concerns.
      </p>
      <p>
        Users may be required to provide documents or information reasonably
        necessary for an investigation.
      </p>

      <h2 className="head"> 20. Account Suspension and Termination</h2>
      <p>
        Orex Trade may suspend, restrict, or terminate an account where there is
        reasonable evidence of fraud, false documents, illegal activity,
        counterfeit products, intellectual-property violations, Buyer-data
        misuse, serious complaints, cybersecurity threats, abusive conduct,
        payment violations, or material breach of these Terms.
      </p>
      <p>
        Where appropriate, Orex Trade may request an explanation or additional
        documentation before permanent termination.
      </p>
      <p>
        Serious fraud, legal violations, or security threats may result in
        immediate suspension.
      </p>

      <h2 className="head"> 21. Platform Availability</h2>
      <p>
        Orex Trade aims to maintain reliable Platform services but does not
        guarantee continuous or uninterrupted availability.
      </p>
      <p>
        Services may occasionally be unavailable because of maintenance,
        upgrades, technical issues, third-party failures, internet outages,
        cybersecurity events, government restrictions, or circumstances beyond
        Orex Trade's reasonable control.
      </p>

      <h2 className="head"> 22. Changes to Platform Services</h2>
      <p>
        Orex Trade may periodically update or modify Platform functionality,
        website design, search algorithms, ranking systems, technical features,
        and services.
      </p>
      <p>
        Orex Trade may also introduce new membership plans, change future
        pricing, or update Platform policies.
      </p>
      <p>
        Material paid membership benefits shall be administered according to the
        membership arrangement applicable to the Supplier.
      </p>

      <h2 className="head"> 23. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by applicable law, Orex Trade shall not
        be responsible for indirect, incidental, consequential, or special
        commercial losses arising from transactions or interactions between
        Platform users.
      </p>
      <p>
        This may include losses relating to Buyer non-payment, failed
        transactions, lost profits, rejected goods, shipment delays,
        product-quality disputes, customs problems, Buyer cancellations,
        fraudulent third-party activities, or independent service-provider
        failures.
      </p>
      <p>
        Nothing in these Terms excludes liability that cannot legally be
        excluded or limited.
      </p>
      <p>
        Where permitted by applicable law, Orex Trade's aggregate contractual
        liability relating to a paid membership shall not exceed the amount
        actually paid by the user for the specific service giving rise to the
        relevant claim.
      </p>

      <h2 className="head"> 24. Indemnification</h2>
      <p>
        To the extent permitted by applicable law, users agree to indemnify Orex
        Trade, its affiliates, directors, officers, employees, and
        representatives against third-party claims arising from the user's
        unlawful activities, fraudulent information, illegal products,
        intellectual-property infringement, regulatory violations,
        product-liability claims, breach of these Terms, or transactions entered
        into with another Platform user.
      </p>

      <h2 className="head"> 25. Privacy and Data Protection</h2>
      <p>
        Orex Trade may collect and process information necessary for
        registration, verification, membership administration, Buyer–Supplier
        connections, business networking, marketing, payment processing, fraud
        prevention, customer support, and compliance.
      </p>
      <p>
        Personal information shall be handled in accordance with the separate
        Privacy Policy and applicable data-protection laws.
      </p>
      <p>
        Business contact information may be displayed or shared with relevant
        Platform members where this forms part of the service being provided.
      </p>

      <h2 className="head"> 26. Confidentiality</h2>
      <p>
        Users must take reasonable steps to protect confidential or non-public
        business information obtained through Orex Trade.
      </p>
      <p>
        This may include Buyer information, Supplier information, RFQs,
        quotations, pricing, sourcing requirements, commercial negotiations, and
        related business information.
      </p>

      <h2 className="head"> 27. Communications</h2>
      <p>
        By registering with Orex Trade, users may receive service-related
        communications concerning account activation, verification, membership,
        Buyer inquiries, RFQs, payments, Platform updates, business
        opportunities, and customer support.
      </p>
      <p>
        Marketing communications shall be handled in accordance with applicable
        laws and the user's available communication preferences.
      </p>

      <h2 className="head">28. Changes to These Terms</h2>
      <p>
        Orex Trade may update these Terms & Conditions periodically to reflect
        changes in law, Platform services, technology, business practices, or
        operational requirements.
      </p>
      <p>
        The latest version will be published on the Platform with the updated
        effective date.
      </p>
      <p>
        Where required, material changes may also be communicated through email,
        account notifications, or other reasonable methods.
      </p>

      <h2 className="head">29. Governing Law and Dispute Resolution</h2>
      <p>
        These Terms & Conditions, and any dispute or claim arising out of or
        relating to the use of the Orex Trade World Platform, membership
        services, or these Terms, shall be governed by and construed in
        accordance with the{" "}
        <b>
          laws of the State of Georgia, United States of America, together with
          applicable federal laws of the United States,
        </b>
        without regard to conflict-of-law principles.
      </p>
      <p>
        The parties agree to first attempt to resolve any dispute, claim, or
        disagreement through good-faith communication and mutual discussion.
      </p>
      <p>
        If a dispute cannot be resolved amicably within <b> thirty (30)</b> days
        after written notice of the dispute, either party may pursue available
        legal remedies in accordance with applicable law.
      </p>
      <p>
        Unless otherwise required by applicable law or expressly agreed in
        writing by the parties, the parties consent to the jurisdiction of the
        <b>
          {" "}
          state and federal courts located in the State of Georgia, United
          States of America
        </b>{" "}
        for disputes arising out of or relating to these Terms, the Platform, or
        the services provided by Orex Trade.
      </p>
      <p>
        Nothing in these Terms shall prevent Orex Trade from seeking injunctive
        or other appropriate equitable relief where reasonably necessary to
        protect its intellectual property, confidential information, Platform
        security, business data, or legal rights.
      </p>
      <p>
        Where mandatory consumer, privacy, data-protection, or other applicable
        laws provide rights that cannot legally be waived or restricted by
        contract, those mandatory rights shall continue to apply.
      </p>

      <h2 className="head">30. Contact Information</h2>
      <p>
        If you have any questions, concerns, complaints, or legal notices
        regarding these Terms & Conditions or the Orex Trade World Platform,
        please contact:
      </p>

      <p><b>Orex Trade World INC</b></p>
      <p><b>Brand :</b>  Orex Trade World </p>
      <p><b>Website: </b><Link to={publicRoutePaths.HOME.path} title="www.orextrade.com">www.orextrade.com </Link> </p>
      <p><b>Email: </b> <a href={`mailto:${process.env.REACT_APP_CONNECT_MAIL}`} title={process.env.REACT_APP_CONNECT_MAIL}>{process.env.REACT_APP_CONNECT_MAIL}</a></p>
      <p><b>Country: </b> United States of America</p>


    </div>
  );
};

export default TermsAndConditionsBuyerSupplier;
